import React, { useCallback, useEffect } from 'react';
import type { Editor } from '@tiptap/react';

import { useHeaderFooterCaret } from 'containers/Tiptap/hooks/use-header-footer-caret';
import { useHeaderFooterKeys } from 'containers/Tiptap/hooks/use-header-footer-keys';
import { useOpenHeaderFooter } from 'containers/Tiptap/hooks/use-header-footer-overlay-editor';
import {
  closeZoneEditor,
  HeaderFooterZone,
  openHeaderFooterKey,
  openZoneEditor,
} from 'containers/Tiptap/lib/header-footer-zone';

import { HeaderFooterHoverOverlay } from './HeaderFooterHoverOverlay';

export const HeaderFooterEditing: React.FC<{ editor: Editor }> = ({ editor }) => {
  const open = useOpenHeaderFooter(editor);
  useHeaderFooterKeys(editor, open !== null);
  useHeaderFooterCaret(open);

  const handleEdit = useCallback(
    (zone: HeaderFooterZone, pageNumber: number): void => {
      if (open) editor.commands.closeHeaderFooterEditors();
      openZoneEditor(editor, zone, pageNumber);
    },
    [editor, open]
  );

  useEffect(() => {
    const dom = editor.view.dom;
    const onDblClick = (event: MouseEvent): void => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('.tiptap-page-header')) closeZoneEditor(editor, 'footer');
      else if (target?.closest('.tiptap-page-footer')) closeZoneEditor(editor, 'header');
    };
    dom.addEventListener('dblclick', onDblClick, true);
    return () => dom.removeEventListener('dblclick', onDblClick, true);
  }, [editor]);

  return <HeaderFooterHoverOverlay root={editor.view.dom} openKey={openHeaderFooterKey(open)} onEdit={handleEdit} />;
};
